/**
 * Calendar V2 Module Entry Point
 * Exports the main container component
 */

import CalendarV2 from './CalendarV2';

export default CalendarV2;
